import { render, staticRenderFns } from "./blankSubject.vue?vue&type=template&id=87f320f6&scoped=true"
import script from "./blankSubject.vue?vue&type=script&lang=js"
export * from "./blankSubject.vue?vue&type=script&lang=js"
import style0 from "./blankSubject.vue?vue&type=style&index=0&id=87f320f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f320f6",
  null
  
)

export default component.exports